import {
  TERMINAL_CLICK_IGNORE_SELECTOR,
  TERMINAL_ROOT_SELECTOR,
} from '../../../utils/constants/terminalConstants';

export function isTerminalTarget(target: EventTarget | null): boolean {
  return (
    target instanceof Element && target.closest(TERMINAL_ROOT_SELECTOR) !== null
  );
}

export function shouldFocusInputOnClick(
  target: EventTarget | null,
  selection: Pick<Selection, 'isCollapsed'> | null,
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }
  if (selection && !selection.isCollapsed) {
    return false;
  }
  return target.closest(TERMINAL_CLICK_IGNORE_SELECTOR) === null;
}
